<template>
  <div style="width:100%">
      <v-row>
          <v-col cols="12" sm="12" md="8" lg="8">
            <duration-stage theme="#36a2eb" 
            :title="DURATION.title" 
            :items="DURATION.items"
            :total="DURATION.total" 
            :filters="filtersItem" />
          </v-col>
          <v-col cols="12" sm="12" md="4" lg="4">
            <campaigns-activities 
            theme="#3F3FFF" 
            :title="ACTIVATION.title" 
            :previews="ACTIVATION.previews" 
            :detail="ACTIVATION.detail" 
            :fields="ACTIVATION.fieldsSet"
            :filters="filterUser"
            :filterCampaigns="filterCampaigns"
            :type="ACTIVATION.type"
            @searchFilter="filterSearch" />
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12" sm="12" md="4" lg="4">
            <campaigns-activities 
            theme="#009688" 
            :title="PAIRING.title" 
            :previews="PAIRING.previews" 
            :detail="PAIRING.detail" 
            :fields="PAIRING.fieldsSet"
            :filters="filterUser"
            :filterCampaigns="filterCampaigns"
            :type="PAIRING.type"
            @searchFilter="filterSearch" />
          </v-col>
          <v-col cols="12" sm="12" md="4" lg="4">
            <campaigns-activities 
            theme="#F44336" 
            :title="CREATING.title" 
            :previews="CREATING.previews" 
            :detail="CREATING.detail" 
            :fields="CREATING.fieldsSet"
            :filters="filterUser"
            :filterCampaigns="filterCampaigns"
            :type="CREATING.type"
            @searchFilter="filterSearch" />
          </v-col>          
          <v-col cols="12" sm="12" md="4" lg="4">
            <campaigns-activities 
            theme="#5F8CDC" 
            :title="COMPLETE.title" 
            :previews="COMPLETE.previews" 
            :detail="COMPLETE.detail" 
            :fields="COMPLETE.fieldsSet"
            :filters="filterUser"
            :filterCampaigns="filterCampaigns"
            :type="COMPLETE.type"
            @searchFilter="filterSearch" />
          </v-col>
      </v-row>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import SpeedHelper from './SpeedHelper'

// Components
import campaignsActivities from './CampaignsActivities'
import DurationStage from './DurationStage.vue'

export default {
  name: 'SpeedStages',
  components: {
    campaignsActivities,
    DurationStage
  },
  props: {
    filterUser: {type: Array}
  },
  data() {
    return {
      breadCrumbsItems: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/co/dashboard'
        },
        {
          text: 'Speed',
          disabled: true,
          href: ''
        }
      ],
      campaigns: [],
      filterCampaigns: [],
      DURATION: {
        title: 'Duration per stage',
        items: [],
        total: {
          top5: {
            activation: 0,
            pairing: 0,
            creating: 0,
            complete: 0,
            overall: 0
          },
          all: {
            activation: 0,
            pairing: 0,
            creating: 0,
            complete: 0,
            overall: 0
          }
        }
      },
      ACTIVATION: {
        title: 'Activation',
        type: 'activation',
        allDetail: [],
        previews: {
          items: [],
          avgBlocks: {
            time: {'avg': 0, 'title': 'Average time to activate'},
            accounts: {'avg': 0, 'title': 'Total Number of accounts'}
          }
        },
        detail: {
          items: [],
          avgBlocks: {
            time: {'avg': 0, 'title': 'Average time to activate'},
            accounts: {'avg': 0, 'title': 'Total Number of accounts'}
          }
        },
        fieldsSet: [
          {
            name: 'name',
            header: 'Campaigns',
            type: 'string',
            format: ['single']
          },
          {
            name: 'days',
            header: 'Days',
            type: 'string',
            format: ['single']
          }
        ]
      },
      CREATING: {
        title: 'CO-CREATING',
        type: 'creating',
        allDetail: [],
        previews: {
          items: [],
          avgBlocks: {
            time: {'avg': 0, 'title': 'Average time to activate'},
            accounts: {'avg': 0, 'title': 'Total Number of accounts'}
          }
        },
        detail: {
          items: [],
          avgBlocks: {
            time: {'avg': 0, 'title': 'Average time to activate'},
            accounts: {'avg': 0, 'title': 'Total Number of accounts'}
          }
        },
        fieldsSet: [
          {
            name: 'name',
            header: 'Campaigns',
            type: 'string',
            format: ['single']
          },
          {
            name: 'days',
            header: 'Days',
            type: 'string',
            format: ['single']
          }
        ]
      },
      PAIRING: {
        title: 'Pairing',
        type: 'pairing',
        allDetail: [],
        previews: {
          items: [],
          avgBlocks: {
            time: {
              'avg': 0,
              'title': 'Average time to activate'
            },
            accounts: {
              'avg': 0,
              'title': 'Total Number of accounts'
            }
          }
        },
        detail: {
          items: [],
          avgBlocks: {
            time: {
              'avg': 0,
              'title': 'Average time to activate'
            },
            accounts: {
              'avg': 0,
              'title': 'Total Number of accounts'
            }
          }
        },
        fieldsSet: [
          {
            name: 'name',
            header: 'Campaigns',
            type: 'string',
            format: ['single']
          },
          {
            name: 'days',
            header: 'Days',
            type: 'string',
            format: ['single']
          }
        ]
      },
      COMPLETE: {
        title: 'Complete',
        type: 'complete',
        allDetail: [],
        previews: {
          items: [],
          avgBlocks: {
            time: {
              'avg': 0,
              'title': 'Average time to submit'
            },
            accounts: {
              'avg': 0,
              'title': 'Total Number of accounts'
            }
          }
        },
        detail: {
          items: [],
          avgBlocks: {
            time: {
              'avg': 0,
              'title': 'Average time to activate'
            },
            accounts: {
              'avg': 0,
              'title': 'Total Number of accounts'
            }
          }
        },
        fieldsSet: [
          {
            name: 'name',
            header: 'Campaigns',
            type: 'string',
            format: ['single']
          },
          {
            name: ['totalPayouts', 'totalPosts'],
            header: 'Submit Payout',
            type: 'string',
            format: ['multiple']
          },
          {
            name: ['yetToPayouts', 'totalPosts'],
            header: 'Yet To Submit',
            type: 'string',
            format: ['multiple']
          }
        ]
      },
      campaignActivity: {
        ACTIVATION: 'activation',
        PAIRING: 'pairing',
        CREATING: 'creating',
        COMPLETE: 'complete'
      },
      seeMoreDialog: false,
      seeMoreHeader: [],
      seeMoreItems: []
    }
  },
  computed: {
    ...mapState(['user']),
    currentUserRole: function() {
      return this.user.role;
    },
    currentUserID: function() {
      return this.user.id;
    }
  },
  async mounted() {
    let response
    // Get all campaigns
    response = await SpeedHelper.getAllCampaignsNoStatus()
    if (response) {
      this.campaigns = response
      this.filterCampaigns = response
      this.filterCampaigns.unshift({id: '', name: 'All Campaigns'})
    }
    await this.getSpeedData(this.ACTIVATION.type, {})
    await this.getSpeedData(this.PAIRING.type, {})
    await this.getSpeedData(this.CREATING.type, {})
    await this.getSpeedData(this.COMPLETE.type, {})
    await this.getDurationStage()
  },
  methods: {
    async getSpeedData(type, filters, filterSource) {
      let typeName = type.toUpperCase()
      let response = await SpeedHelper.getSpeedData(type, filters)
      if (response) {
        // to differentiate preview lists & detail modal
        //
        if (!filterSource) { // get all detail at init to caculate for duration per stage
          this[typeName].allDetail = response.all
        }
        if (!filterSource || (filterSource && filterSource === 'previews')) { // if no filters or preview filter exists
          this[typeName].previews.items = response.previews
          this[typeName].previews.avgBlocks.time.avg = response.avgTime
          if (type !== this.COMPLETE.type) { // For COMPLETE, total accounts not needed
            this[typeName].previews.avgBlocks.accounts.avg = response.totalAccounts
          }
        }
        if (!filterSource || (filterSource && filterSource === 'detail')) { // if no filters or detail filter exists
          this[typeName].detail.items = response.all
          this[typeName].detail.avgBlocks.time.avg = response.avgTime
          if (type !== this.COMPLETE.type) {
            this[typeName].detail.avgBlocks.accounts.avg = response.totalAccounts
          }
        }
      }
    },
    async filterSearch(filters) {
      this.getSpeedData(filters.type, filters.filter, filters.filterSource)
    },
    async getDurationStage() {
      // calculate duration per stage, avg based on campaign activity types foreach CO
      let vm = this
      this.DURATION.items = this.filterUser.map(c => {
        let totalDays = 0
        Object.keys(this.campaignActivity).map(function(key) {
          let activationCampaigns = vm[key].allDetail.filter(a => a.assignedTo && a.assignedTo.includes(c.id))
          let activationDays = activationCampaigns.map(c => c.days).reduce((one, two) => one + two, 0)
          c[key] = activationDays > 0 ? Math.round(activationDays / activationCampaigns.length, 0) : 0
          totalDays += c[key]
        })
        c.Overall = totalDays > 0 ? Math.round(totalDays / Object.keys(this.campaignActivity).length, 0) : 0
        return c
      })
      // calculate total durations
      this.DURATION.items = this.DURATION.items.filter(d => d.id !== '')
      this.DURATION.items = Object.assign([], this.DURATION.items.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1))
      this.DURATION.total.top5 = this.calculateTotalDuration(this.DURATION.items.slice(0, 6))
      this.DURATION.total.all = this.calculateTotalDuration(this.DURATION.items)
    },
    calculateTotalDuration(items) {
      let vm = this
      let total = {}
      Object.keys(this.campaignActivity).map(function(key) {
        total[vm.campaignActivity[key]] = 0
      })
      items.map(item => {
        Object.keys(this.campaignActivity).map(function(key) {
          total[vm.campaignActivity[key]] += item[key]
        })
      })
      let allTotal = 0
      Object.keys(this.campaignActivity).map(function(key) {
        total[vm.campaignActivity[key]] = Math.round(total[vm.campaignActivity[key]] / items.length, 0)
        allTotal += total[vm.campaignActivity[key]]
      })
      total.overall = allTotal > 0 ? Math.round(allTotal / Object.keys(this.campaignActivity).length, 0) : 0
      return total
    }
  }
}
</script>
<style scoped>
@font-face {
    font-family: WorkSans-Regular;
    src: url('/static/fonts/WorkSans-Regular.ttf');
}
@font-face {
    font-family: WorkSans-ExtraLight;
    src: url('/static/fonts/WorkSans-ExtraLight.ttf');
}
@font-face {
    font-family: WorkSans-SemiBold;
    src: url('/static/fonts/WorkSans-SemiBold.ttf');
}
@font-face {
    font-family: WorkSans-Medium;
    src: url('/static/fonts/WorkSans-Medium.ttf');
}
</style>



// WEBPACK FOOTER //
// SpeedStages.vue?2d9d5934